import { RootStore } from "./RootStore";
import { BaseStore } from "./BaseStore";
import { User } from "../models/User";

export class UserStore extends BaseStore<User> {
  constructor(store: RootStore) {
    super(store, User);
  }
}
